import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RECOMMENDATION } from "utils/CommonConstants";
import { responseTypes } from "utils/Types";
import { axiosPost, axiosPut } from "../../../../utils/APIHelper";
import { SuggestedPlanState } from "./Suggested";

const initialState: SuggestedPlanState = {
  topSuggestedPlanIds: [],
  topSuggestedPlansList: [],
  listIds: [],
  status: "idle",
  totalRecords: 0,
  SuggestedPlansList: [],
  newAreaOfFocusesAvailable: false,
  removeInvalidPlan: {},
  suggestedShowLoader: false,
  topSuggestedShowLoader: false,
  plansMetrics: [],
  selectedFocusAreas: []
};

export const fetchSuggestedPlansIdAsync = createAsyncThunk("Library/suggestedPlansIds", async (data: any, thunkApi) => {
  const API_URL = `suggestedPlans?innCode=${data.innCode}&externalHltId=${data?.externalHltId || ""}`;
  const response: any = await axiosPut(API_URL, "recommendation");
  if (
    response?.response?.status >= responseTypes.internal_error &&
    response?.response?.status < responseTypes.other_error
  ) {
    return thunkApi.rejectWithValue(response.response);
  }

  return {
    dashboardMetrics: response.data.metrics,
    suggestedPlans: response.data.suggestedPlans,
    getTopSuggested: data.getTopSuggested,
    newAreaOfFocusesAvailable: response.data.newAreaOfFocusesAvailable,
    selectedFocusAreas: response.data.selectedFocusAreas
  };
});

export const fetchSuggestedPlansAsync = createAsyncThunk("Library/fetchsuggestedPlans", async (data: any, thunkApi) => {
  const { topSuggested, externalHltId, ...APIdata } = data;
  const API_URL = `plans?externalHltId=${externalHltId}`;
  const response: any = await axiosPost(API_URL, "", {
    ...APIdata,
    myPlansDisabled: true
  });
  if (response.response?.status === responseTypes.error) {
    return thunkApi.rejectWithValue(response.response.data);
  }
  return { ...response.data, topSuggested };
});

export const submitSuggestedPlansFeedbackAsync = createAsyncThunk(
  "Library/submitsuggestedPlansFeedback",
  async (data: {}, thunkApi) => {
    const API_URL = "feedbacks";
    const response: any = await axiosPut(API_URL, RECOMMENDATION, {
      ...data
    });
    if (response.response?.status === responseTypes.error) {
      return thunkApi.rejectWithValue(response.response.data);
    }
    return response.data;
  }
);

export const SuggestedPlanSlice = createSlice({
  name: "suggestedPlan",
  initialState,
  reducers: {
    setSuggestedPlanList(state) {
      state.SuggestedPlansList = [];
      state.suggestedShowLoader = false;
    },

    removePlans(state) {
      state.topSuggestedPlanIds = [];
      state.topSuggestedPlansList = [];
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSuggestedPlansIdAsync.pending, (state) => {
        state.listIds = [];
        state.status = "loading";
        state.topSuggestedPlanIds = [];
        state.suggestedShowLoader = true;
        state.topSuggestedShowLoader = true;
      })
      .addCase(fetchSuggestedPlansIdAsync.fulfilled, (state, action: any) => {
        state.newAreaOfFocusesAvailable = action.payload.newAreaOfFocusesAvailable;
        state.selectedFocusAreas = action.payload.selectedFocusAreas;
        state.plansMetrics = [...action.payload.suggestedPlans];
        if (!action.payload.suggestedPlans.length) {
          state.status = "idle";
          state.suggestedShowLoader = false;
          state.topSuggestedShowLoader = false;
        } else {
          if (action.payload.getTopSuggested && action.payload.suggestedPlans.length > 0) {
            state.topSuggestedPlanIds = action.payload.suggestedPlans.splice(0, 3);
          }
          state.listIds = action.payload.suggestedPlans;
        }
      })
      .addCase(fetchSuggestedPlansIdAsync.rejected, (state) => {
        state.status = "idle";
        state.listIds = [];
        state.topSuggestedPlanIds = [];
        state.suggestedShowLoader = false;
        state.topSuggestedShowLoader = false;
        state.SuggestedPlansList = [];
      })
      .addCase(fetchSuggestedPlansAsync.pending, (state, action: any) => {
        state.status = "loading";
        if (action.meta.arg.pagination.page === 1) {
          state.topSuggestedShowLoader = true;
        }
      })
      .addCase(fetchSuggestedPlansAsync.fulfilled, (state, action: any) => {
        if (action.payload.topSuggested) {
          state.topSuggestedPlansList = action.payload.plans;
        } else {
          state.SuggestedPlansList =
            action.meta.arg.pagination.page === 1
              ? action.payload.plans
              : [...state.SuggestedPlansList, ...action.payload.plans];
          state.totalRecords = action.payload.meta?.page?.total;
          state.suggestedShowLoader = false;
        }
        state.topSuggestedShowLoader = false;
        state.suggestedShowLoader = false;
        state.status = "idle";
      })
      .addCase(fetchSuggestedPlansAsync.rejected, (state) => {
        state.status = "failed";
        state.SuggestedPlansList = [];
        state.suggestedShowLoader = false;
        state.topSuggestedShowLoader = false;
      })
      .addCase(submitSuggestedPlansFeedbackAsync.pending, (state, action: any) => {
        state.suggestedShowLoader = true;
      })
      .addCase(submitSuggestedPlansFeedbackAsync.fulfilled, (state, action: any) => {
        state.status = "idle";
        state.removeInvalidPlan = action.payload;
        state.suggestedShowLoader = false;
      });
  }
});

export const { setSuggestedPlanList, removePlans } = SuggestedPlanSlice.actions;

export default SuggestedPlanSlice.reducer;
